import { render, staticRenderFns } from "./ImageWithPreview.vue?vue&type=template&id=896ad6d2&scoped=true"
import script from "./ImageWithPreview.vue?vue&type=script&lang=js"
export * from "./ImageWithPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896ad6d2",
  null
  
)

export default component.exports